var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex py-3 align-center" },
    [
      _c(
        "v-list-item-avatar",
        { staticClass: "my-0" },
        [_c("v-img", { attrs: { src: _vm.avatar } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "v-list-item-title",
            { staticClass: "align-self-center" },
            [
              _c(
                "Link",
                {
                  attrs: { href: _vm.href },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(_vm.title) + "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-list-item-subtitle", [
            _vm._v("\n            " + _vm._s(_vm.subtitle) + "\n        "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }